/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsConversationRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.reviews.conversation',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsConversationRoute, {
  overrideRenderTemplate: false,
});
